import { ISubscriptionProduct } from '@pressreader/commerce-types';
import { ISubscriptionProductDto } from '../types';

function mapFromSubscriptionProductDto(dto: ISubscriptionProductDto): ISubscriptionProduct {
    return { ...dto };
}

export { mapFromSubscriptionProductDto };
